import { type AccountFeatureActivationRead } from '@libraries/typescript/api_client';

export const ACCOUNT_FEATURES = [
    {
        key: 'voip_integration',
        label: 'VOIP Integration',
        group: 'core',
    },
    {
        key: 'auto_coverage',
        label: 'Auto-Coverage',
        group: 'core',
    },
    {
        key: 'general_agent',
        label: 'General Agent',
        group: 'core',
    },
    {
        key: 'clock_in_out',
        label: 'Clock In / Out',
        group: 'expansion',
    },
    {
        key: 'imessage',
        label: 'iMessage',
        group: 'expansion',
    },
    {
        key: 'slack',
        label: 'Slack',
        group: 'expansion',
    },
] as const;

export type AccountFeature = (typeof ACCOUNT_FEATURES)[number];
export type AccountFeatureKey = AccountFeature['key'];
export type AccountFeatureGroup = AccountFeature['group'];

export type AccountFeatureActivationSummary = {
    readonly core: {
        readonly active: number;
        readonly total: number;
    };
    readonly expansion: {
        readonly active: number;
        readonly total: number;
    };
};

export function activatedFeatureKeys(
    activations: ReadonlyArray<AccountFeatureActivationRead>,
): Array<string> {
    return activations.map((activation) => activation.feature_key);
}

export function activationSummary(
    activations: ReadonlyArray<AccountFeatureActivationRead>,
): AccountFeatureActivationSummary {
    const activeFeatureKeys = new Set(activatedFeatureKeys(activations));
    const coreFeatures = ACCOUNT_FEATURES.filter(
        (feature) => feature.group === 'core',
    );
    const expansionFeatures = ACCOUNT_FEATURES.filter(
        (feature) => feature.group === 'expansion',
    );

    return {
        core: {
            active: coreFeatures.filter((feature) =>
                activeFeatureKeys.has(feature.key),
            ).length,
            total: coreFeatures.length,
        },
        expansion: {
            active: expansionFeatures.filter((feature) =>
                activeFeatureKeys.has(feature.key),
            ).length,
            total: expansionFeatures.length,
        },
    };
}
